/**
 * Enum quý
 * Created by: nvcuong1 09/05/2025
 */
export default {
  QuarterI: 1,
  QuarterII: 2,
  QuarterIII: 3,
  QuarterIV: 4
};
